// extracted by mini-css-extract-plugin
export default {"paddingTop":"ContactUsSection_paddingTop__RIB6Q"};